import React from "react";
import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(theme => ({
  label: {
    color: theme.palette.primary.dark,
  },
}));

const LabeledReadOnly = ({ label, children }) => {
  const classes = useStyles();

  return (
    <Box>
      <Typography
        variant="h3"
        component="div"
        gutterBottom
        classes={{ root: classes.label }}
      >
        {label}
      </Typography>
      {children}
    </Box>
  );
};

export default LabeledReadOnly;
